import * as React from 'react';
import Typography from '@mui/material/Typography';
import firebase from "firebase/compat/app";
import { Button } from '@mui/material';
import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import { CircularProgress } from '@mui/material';
//import { DicomUploads } from '../upload/Upload';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import { v4 as uuidv4 } from 'uuid';
import { db } from '../../Environment/firebase';
import { collection, doc, setDoc, query, where, getDocs, orderBy,startAt,endAt, Query } from "firebase/firestore";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getDatabaseData } from '../../Functions/APIservice/useDatabase';
import CaseSearchBox from '../../Modules/ViewCase/CaseSearchBox';
import CaseTable,{createCaseTableData} from '../../Modules/ViewCase/CaseTable';

export type CatalogueTableRowType = { 
  id:string,
  patientId:string,
  title:string, 
  sites:string[], 
  modality:string,
  date:string,
  tags:string[]
}



export default function CatalogueTable() {


  const [rows,setRows] = React.useState<CatalogueTableRowType[]>([]);
  const [title,setTitle] = React.useState('');
  const [searchTime,setSearchTime] = React.useState(false);
  const [ID,setID] = React.useState('');
  const [tags,setTags] = React.useState('');
  const [filterSite, setFilterSite] = React.useState(0);
  const [filterModal, setFilterModal] = React.useState(0);
  const [dicoms,setDicoms] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [upload, setUpload] = React.useState(false);
  const [uploading,setUploading] = React.useState(false);


  const Modalstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 500,
    minWidth:300,
    display:'grid',
    alignItems: 'center',
    justify:"center",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  
    React.useEffect(()=>{
      getDatabaseData('dwh','destInstitutionCode','==',"d151f295-42db-f3b4-a456-d1ad2ac17f09")
      .then((rowDatas)=>{
        const baseDatas = rowDatas.map((data)=>{
          const content = data.value
          //const date = new Date(content.createTime.seconds * 1000 + content.createTime.nanoseconds / 1000)
          return createCaseTableData(
            content.id, content.patientId,content.patientId, content.site , content.modality ,content.studyDate, content.TagInformation
          )
        })
        const baseDatasSorted = baseDatas.sort((a, b) => a.date < b.date ? 1:-1)
        setRows(baseDatasSorted)});
    },[]);

    const getRowQuery = async (target:string,value:string) => {
      const datalist:CatalogueTableRowType[] = []
      const databaseRef = collection(db, "dwh");
      let q: Query<firebase.firestore.DocumentData>;
      if(target === 'patientId'){
        q = query(databaseRef, where("patientId", "==", value),where('destInstitutionCode','==',"d151f295-42db-f3b4-a456-d1ad2ac17f09"));    
      }else if((target === 'KeyWord')||(target === 'site')){
        q = query(databaseRef,where('destInstitutionCode','==',"d151f295-42db-f3b4-a456-d1ad2ac17f09"))
      }else{
        q = query(databaseRef)
      }
      const querySnapshot = await getDocs(q);   
        if (querySnapshot.docs.length === 0) {
          console.log('データは0件です')
        } else {
        querySnapshot.forEach((doc) => {
            const content:firebase.firestore.DocumentData = doc.data()
            if(target === 'KeyWord'){
              if (content.findings.includes(value) || content.diagnosis.includes(value)){
                datalist.push(createCaseTableData(
                   content.id, content.patientId,content.patientId, content.site , content.modality ,content.studyDate, content.TagInformation
                ))}
              }else if(target === 'site'){
              if(content.site.includes(value)){
                  datalist.push(createCaseTableData(
                    content.id,content.patientId,content.patientId, content.site , content.modality ,content.studyDate, content.TagInformation
                  ))
                }
            }else{
            datalist.push(createCaseTableData(
              content.id,content.patientId, content.patientId, content.site , content.modality ,content.studyDate, content.TagInformation
            ));
            }
        })};
    return datalist
    }

    const searchDatabase = (querydict:{id:string,keyword:string,site:string}) => {
      setSearchTime(true);
      //var newRoes;
      if(querydict.id !== ''){
        getRowQuery('patientId',querydict.id)
        .then((rowDatas)=>{
          setRows(rowDatas);
          setSearchTime(false);
        })
      }else{
        if(querydict.keyword !== ''){
          getRowQuery('KeyWord',querydict.keyword)
          .then((rowDatas)=>{
            setRows(rowDatas);
            setSearchTime(false);
          })
        }else if(querydict.site !== ''){
          getRowQuery('site',querydict.site)
          .then((rowDatas)=>{
            setRows(rowDatas);
            setSearchTime(false);
          })
        }      
      }
    }
  
    return (
    <React.Fragment>
    <Box sx={{ width: '95%',minHeight: '70vh' , m: 2 }}>
        <Grid display={{md:'flex',sm:'grid'}} gap={2}>
          <CaseSearchBox queryfunction={(dataset)=>searchDatabase(dataset)}></CaseSearchBox>
        </Grid>
        <div>
          {searchTime?
          <Grid>
            <CircularProgress/>
            <Typography>検索中です</Typography>
          </Grid>
          :
          <CaseTable rows={rows} management={true}></CaseTable>
          }
        </div>
    </Box>
    </React.Fragment>
  );
}